import { IComponentsApiRegistry, IComponentApiProvider } from '../componentsApiInfrastructure'

/**
 * Base implementation of interfaces which is responsible for registry and providing of APIs of ActionCard components
 */
export class ComponentsApiContainer implements IComponentsApiRegistry, IComponentApiProvider {
  readonly #map: Map<number, unknown> = new Map<number, unknown>()

  register<T>(nodeId: number, api: T): void {
    this.#map.set(nodeId, api)
  }

  unregister(nodeId: number): void {
    this.#map.delete(nodeId)
  }

  get<T>(nodeId: number): T | undefined {
    return this.#map.get(nodeId) as T | undefined
  }
}
